module.exports = __webpack_public_path__ + "img/logo-en.be338d37.svg";